<div [class]="continentFieldClass">
	<label class="qs-label">
		{{ 'common.countrySelect.continent' | transloco }}
		@if (required) {
			<span class="qs-req">*</span>
		}
	</label>
	<app-select
		[options]="continentOptions"
		[ngModel]="continent()"
		[ngModelOptions]="{ standalone: true }"
		(ngModelChange)="onContinentChange($event)"
		[disabled]="disabled"
		[error]="error"
		[appendTo]="appendTo"
		[size]="size"
		(onHide)="touch()"
		[placeholder]="'common.countrySelect.selectContinent' | transloco"></app-select>
</div>

<div [class]="countryFieldClass">
	<label class="qs-label">
		{{ countryLabelKey | transloco }}
		@if (required) {
			<span class="qs-req">*</span>
		}
		@if (badge) {
			<span class="cs-badge">{{ badge }}</span>
		}
	</label>
	<app-select
		[options]="countryOptions"
		[ngModel]="countryCode()"
		[ngModelOptions]="{ standalone: true }"
		(ngModelChange)="onCountryChange($event)"
		[disabled]="disabled || !continent()"
		[error]="error"
		[filter]="true"
		[appendTo]="appendTo"
		[size]="size"
		(onHide)="touch()"
		[filterPlaceholder]="'common.countrySelect.searchCountry' | transloco"
		[placeholder]="
			(continent() ? 'common.countrySelect.selectCountry' : 'common.countrySelect.continentFirst') | transloco
		"></app-select>
</div>
